import { render, staticRenderFns } from "./GLayoutBox.vue?vue&type=template&id=55d1a99e&scoped=true&"
import script from "./GLayoutBox.vue?vue&type=script&lang=ts&"
export * from "./GLayoutBox.vue?vue&type=script&lang=ts&"
import style0 from "./GLayoutBox.vue?vue&type=style&index=0&id=55d1a99e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d1a99e",
  null
  
)

export default component.exports